// extracted by css-extract-rspack-plugin
export default {"stepBar":"header-fragment__StepBar_stepBar__QSoFw"};